import { Injectable } from "@nestjs/common";
import { CommonResponseModel, SamplecoLineFilterReq, StatusEnum, coLineFilter } from "@project-management-system/shared-models";
import { ExternalReq } from "packages/libs/shared-models/src/common/pvh/externalreq";
import { DataSource } from "typeorm";
import { DeliveryMethodEnum } from '../../../../../libs/shared-models/src/Enum/sample-po/delivery-method.enum';
import { DeliveryTermsEnum } from '../../../../../libs/shared-models/src/Enum/sample-po/delivery-terms.enum';
import { ItemResponsibleEnum } from '../../../../../libs/shared-models/src/Enum/sample-po/iem-responsible.enum';
import { PackaginTrimsEnum } from '../../../../../libs/shared-models/src/Enum/sample-po/packaging-trims.enum';
import { PaymentMethodEnum } from '../../../../../libs/shared-models/src/Enum/sample-po/payment-method.enum';
import { PaymentTermsEnum } from '../../../../../libs/shared-models/src/Enum/sample-po/payment-terms.enum';
import { SalesPersonEnum } from '../../../../../libs/shared-models/src/Enum/sample-po/sales-person.enum';
import { ExcelColumn } from '../../../../../libs/shared-models/src/common/sample-po/excel-req';
import { SamplePoOrderDataModel } from '../../../../../libs/shared-models/src/common/sample-po/sample-po-orders-model';
import { GenericTransactionManager } from "../../typeorm-transactions";
// import { ExcelEntity } from "./entities/sample-po-order.entity";
// import { SamplePoOrdersEntity } from "./entities/buyer-master.entity";
// import { ExcelRepository } from "./repositories/sample-po-order.repo";
// import { SamplePoOrdersRepo } from "./repositories/buyer-master.repo";
import { Cron } from "@nestjs/schedule";
import * as nodemailer from 'nodemailer';
import { SamplecoLineDto } from "./dto/sample-co-line.dto";
import { buyerEntity } from "./entities/buyer-master.entity";
import { SamplecoLineEntity } from "./entities/sample-coLine.entity";
import { SamplePoOrderEntity } from "./entities/sample-po-order.entity";
import { BuyerMasterRepo } from "./repositories/buyer-master.repo";
import { SampleCoLineRepo } from "./repositories/sample-co-line-repo";
import { samplePoOrderRepository } from "./repositories/sample-po-order.repo";
import dayjs = require("dayjs");
const { Builder, Browser, By, Select, until, Key } = require('selenium-webdriver');
// import dayjs from 'dayjs';

@Injectable()
export class SamplePoService {
  constructor(
    private dataSource: DataSource,
    private buyerRepo: BuyerMasterRepo,
    private repo: samplePoOrderRepository,
    private colineRepo: SampleCoLineRepo
  ) { }

  async OrdersSaveData(req?: SamplePoOrderDataModel, isUpdate?: boolean): Promise<any> {
    try {
      const entity = new buyerEntity();
      entity.id = req.id;
      entity.buyerName = req.buyerName;
      entity.OrdersbuyerCode = req.OrdersbuyerCode.trim();
      entity.salesPerson = req.salesPerson as SalesPersonEnum;
      entity.itemResponsible = req.itemResponsible as ItemResponsibleEnum;
      entity.deliveryTerms = req.deliveryTerms as DeliveryTermsEnum
      entity.discountOne = req.discountOne;
      entity.discountTwo = req.discountTwo;
      entity.packagingTrims = req.packagingTrims as PackaginTrimsEnum
      entity.deliveryMethod = req.deliveryMethod as DeliveryMethodEnum
      entity.paymentMethod = req.paymentMethod as PaymentMethodEnum
      entity.paymentTerms = req.paymentTerms as PaymentTermsEnum
      entity.shipmentType = req.shipmentType
      // entity.buyerPo = "SMS"
      entity.agent = "NA-DIRECT CUSTOMER"
      entity.facility = "370"
      entity.wareHouse = "370"
      // entity.shipmentType = "RETAIL STORE"
      entity.spQty = "1"
      entity.pch = "KNT"
      if (isUpdate) {
        entity.id = req.id
        entity.updatedUser = req.updatedUser
      } else {
        entity.createdUser = req.createdUser
      }
      const save = await this.buyerRepo.save(entity);
      if (save) {
        return new CommonResponseModel(true, 1, isUpdate ? 'Order Updated Sucessfully' : 'Order Created Sucessfully', [])
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Error', err);
    }
  }
  // async saveExcelInfo(formData: any): Promise<CommonResponseModel> {
  //   const transactionManager = new GenericTransactionManager(this.dataSource);
  //   try {
  //     await transactionManager.startTransaction();
  //     const flag = new Set<boolean>();
  //     const columnArray = [];
  //     const updatedArray = formData.map((obj) => {
  //       const updatedObj = {};
  //       for (const key in obj) {
  //         const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '').replace(/#/g, '').replace(/%/g, "");
  //         if (newKey != '') {
  //           columnArray.push(newKey);
  //           updatedObj[newKey] = obj[key];
  //         }
  //       }
  //       return updatedObj;
  //     });
  //     const difference = columnArray.filter((element) => !ExcelColumn.includes(element));
  //     console.log(difference, "diff");
  //     if (difference.length > 0) {
  //       await transactionManager.releaseTransaction();
  //       return new CommonResponseModel(false, 1110, "Excel columns don't match. Please attach the correct file.");
  //     }

  //     const convertedData = updatedArray.map((obj) => {
  //       const updatedObj = {};
  //       for (const key in obj) {
  //         const value = obj[key];
  //         if (value === "") {
  //           updatedObj[key] = null;
  //         } else {
  //           updatedObj[key] = value;
  //         }
  //       }
  //       return updatedObj;
  //     });
  //     const deleteData = await this.repo.createQueryBuilder()
  //       .delete()
  //       .from(SamplePoOrderEntity)
  //       .where("buyerStyle = :buyerStyle", { buyerStyle: convertedData[0]?.BuyerStyle })
  //       .execute();
  //     console.log('delete', deleteData);
  //     if (deleteData) {
  //       flag.add(true);
  //     } else {
  //       flag.add(false);
  //       return new CommonResponseModel(false, 0, 'Something went wrong in data deletion');
  //     }
  //     for (const data of convertedData) {
  //       console.log(data, "iiiiii");
  //       if (data) {
  //         const addObj = new SamplePoOrderEntity();
  //         addObj.buyerStyle = data.BuyerStyle;
  //         addObj.buyerCode = data.BuyerCode;
  //         addObj.buyerAddress = data.BuyerAddress;
  //         addObj.earliestExFty = data.Earliestexfty
  //         addObj.deliveryDate = data.DeliveryDateHeader;
  //         addObj.deliveryAddress = data.Deliveryaddress;
  //         addObj.itemDescription = data.Itemdescription;
  //         addObj.orderQty = data.Orderqty;
  //         addObj.salesPrice = data.Salesprice;
  //         addObj.currency = data.Currency;
  //         addObj.sampleItemNo = data.SampleItemNo
  //         addObj.discountItem = data.DisItem

  //         const addSave = await transactionManager.getRepository(SamplePoOrderEntity).save(addObj);
  //         if (addSave) {
  //           flag.add(true);
  //         } else {
  //           flag.add(false);
  //           await transactionManager.releaseTransaction();
  //           break;
  //         }
  //       }
  //     }
  //     if (!flag.has(false)) {
  //       await transactionManager.completeTransaction();
  //       return new CommonResponseModel(true, 1, 'Data saved successfully');
  //     } else {
  //       await transactionManager.releaseTransaction();
  //       return new CommonResponseModel(false, 0, 'Something went wrong');
  //     }
  //   } catch (err) {
  //     await transactionManager.releaseTransaction();
  //     return new CommonResponseModel(false, 0, 'Something went wrong');
  //   }
  // }

  async saveExcelInfo(formData: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);

    try {
      await transactionManager.startTransaction();
      const columnArray = [];
      const updatedArray = formData.map((obj) => {
        const sanitizedObj = {};
        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const newKey = key
              .replace(/\s/g, '')
              .replace(/[\(\)\.]/g, '')
              .replace(/-/g, '')
              .replace(/#/g, '');
            if (newKey) {
              columnArray.push(newKey);
              sanitizedObj[newKey] = obj[key];
            }
          }
        }
        return sanitizedObj;
      });

      const invalidColumns = columnArray.filter((col) => !ExcelColumn.includes(col));
      if (invalidColumns.length > 0) {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 1110, "Excel columns don't match. Please attach the correct file.");
      }
      const filteredArray = updatedArray.filter((obj) =>
        Object.values(obj).every(
          (value) => value !== null && value !== '' && value !== '-' && value !== ' '
        )
      );
      const convertedData = filteredArray.map((obj) => {
        const result = {};
        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            result[key] = obj[key] === "" ? null : obj[key];
          }
        }
        return result;
      });
      const repository = transactionManager.getRepository(SamplePoOrderEntity);

      for (const data of convertedData) {
        if (!data) continue;

        console.log(data, "data")
        try {
          const existingRecord = await repository.findOne({
            where: {
              buyerStyle: data.BuyerStyle,
              buyerCode: data.BuyerCode.trim(),
              buyerAddress: data.BuyerAddress,
              earliestExFty: dayjs(data["EarliestexftyDD/MM/YYYY"], "DD/MM/YYYY").isValid()
                ? dayjs(data["EarliestexftyDD/MM/YYYY"]).add(5, 'hours').add(30, 'minutes').format("DD/MM/YYYY")
                : null,
              deliveryDate: dayjs(data["DeliveryDateHeaderDD/MM/YYYY"], "DD/MM/YYYY").isValid()
                ? dayjs(data["DeliveryDateHeaderDD/MM/YYYY"]).add(5, 'hours').add(30, 'minutes').format("DD/MM/YYYY")
                : null,
              deliveryAddress: data.Deliveryaddress,
              itemDescription: data.Itemdescription,
              orderQty: data.Orderqty,
              salesPrice: data.Salesprice,
              currency: data.Currency,
              sampleItemNo: data.SampleItemNo,
              discountItem: data["Dis%Item"],
              buyerPo: data.BuyerPO
            },
          });

          if (existingRecord) {
            continue;
          }

          const newRecord = {
            buyerStyle: data.BuyerStyle,
            buyerCode: data.BuyerCode.trim(),
            buyerAddress: data.BuyerAddress,
            earliestExFty: dayjs(data["EarliestexftyDD/MM/YYYY"]).add(5, 'hours').add(30, 'minutes').format("DD/MM/YYYY"),
            deliveryDate: dayjs(data["DeliveryDateHeaderDD/MM/YYYY"]).add(5, 'hours').add(30, 'minutes').format("DD/MM/YYYY"),
            deliveryAddress: data.Deliveryaddress,
            itemDescription: data.Itemdescription,
            orderQty: data.Orderqty,
            salesPrice: data.Salesprice,
            currency: data.Currency,
            sampleItemNo: data.SampleItemNo,
            discountItem: data["Dis%Item"],
            buyerPo: data.BuyerPO
          };

          const savedRecord = await repository.save(newRecord);

          if (!savedRecord) {
            console.error("Failed to save record:", data);
            throw new Error("Failed to save record");
          }
        } catch (innerError) {
          console.error("Error processing record:", data, innerError);
          throw innerError;
        }
      }

      await transactionManager.completeTransaction();
      return new CommonResponseModel(true, 1, "Data saved successfully");
    } catch (err) {
      console.error("Error in saveExcelInfo:", err);
      return new CommonResponseModel(false, 0, "Something went wrong");
    } finally {
      await transactionManager.releaseTransaction();
    }
  }


  // formatDate(dateString) {
  //   const date = new Date(dateString);
  //   date.setDate(date.getDate() + 1);
  //   const formattedDate = `${this.padZero(date.getDate())}/${this.padZero(date.getMonth() + 1)}/${date.getFullYear()}`;
  //   return formattedDate;
  // }
  // padZero(num) {
  //   return num.toString().padStart(2, '0');
  // }

  async getColorInfo(req?: ExternalReq): Promise<CommonResponseModel> {
    try {
      let info;
      if (req.externalRef === "") {
        info = await this.repo.find({
          order: { createdAt: "DESC" }
        });
      } else {
        info = await this.repo.find({
          where: { buyerStyle: req.externalRef },
          order: { createdAt: "DESC" } 
        });
      }
      if (info && info.length > 0) {
        return new CommonResponseModel(true, 1, 'Data retrieved', info);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Something went wrong', err);
    }
  }

  async getSampleOrderAcceptanceData(req?: SamplecoLineFilterReq): Promise<CommonResponseModel> {
    try {
      const details = await this.buyerRepo.getSampleOrderAcceptanceData(req)
      if (details.length > 0) {
        return new CommonResponseModel(true, 0, 'Data retrieved successfully', details)
      } else {
        return new CommonResponseModel(false, 1, 'No data found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getOrders(): Promise<CommonResponseModel> {
    try {
      let query = `
   SELECT 
    spo.id,
    spo.buyer_name AS buyerName,
    spo.buyer_code AS OrdersbuyerCode,
    spo.sales_person AS salesPerson,
    spo.item_responsible AS itemResponsible,
    spo.delivery_terms AS deliveryTerms,
    spo.discount_one AS discountOne,
    spo.discount_two AS discountTwo,
    spo.packaging_trims AS packagingTrims,
    spo.delivery_method AS deliveryMethod,
    spo.payment_method AS paymentMethod,
    spo.payment_terms AS paymentTerms,
    spo.facility,
    spo.ware_house AS wareHouse,
    spo.pch,
    spo.buyer_po_date AS buyerPoDate,
    spo.buyer_po AS buyerPo,
    spo.shipment_type AS shipmentType,
    spo.agent,
    spo.sp_qty AS spQty
    FROM  buyer_master spo`;
      const result = await this.buyerRepo.query(query)
      if (result) {
        return new CommonResponseModel(true, 123, "Data Retrived SucessFully", result)
      } else {
        return new CommonResponseModel(false, 0, "No Data Found", [])

      }
    }
    catch (err) {
      throw (err)
    }
  }

  //   async getAllOrdersDetails(): Promise<CommonResponseModel> {
  //     try {
  //       let query = `SELECT 
  //     spo.buyer_style AS buyerStyle,
  //     spo.buyer_code AS OrdersbuyerCode,
  //     spo.buyer_address AS buyerAddress,
  //     spo.earliest_ex_fty AS earliestExFty,
  //     spo.delivery_date AS deliveryDate ,
  //     spo.delivery_address AS deliveryAddress,
  //     spo.item_description AS itemDescription,
  //     spo.order_qty AS orderQty,
  //     spo.sales_price AS salesPrice,
  //     spo.discount_item,
  //     spo.currency,
  //     spo.status,
  //     spo.buyer_po AS buyerPo,
  //     spo.sample_item_no,
  //     bm.buyer_name AS buyerName,
  //     bm.sales_person AS salesPerson ,
  //     bm.discount_one AS discountOne,
  //     bm.item_responsible AS itemResponsible,
  //     bm.delivery_terms  AS deliveryTerms,
  //     bm.packaging_trims AS packagingTrims,
  //     bm.delivery_method AS deliveryMethod ,
  //     bm.payment_method  AS paymentMethod,
  //     bm.payment_terms AS paymentTerms,
  //     bm.facility ,
  //     bm.ware_house AS wareHouse,
  //     bm.pch,
  //     bm.buyer_po_date AS buyerPoDate,
  //     bm.shipment_type  AS shipmentType,
  //     bm.agent,
  //     bm.sp_qty AS spQty
  // FROM  sample_po_order spo
  // LEFT JOIN buyer_master bm ON  bm.buyer_code = spo.buyer_code`
  //       const result = await this.buyerRepo.query(query)
  //       if (result.length > 0) {
  //         return new CommonResponseModel(true, 123, "Data Retrived SucessFully", result)
  //       } else {
  //         return new CommonResponseModel(false, 0, "No Data Found", [])

  //       }
  //     }
  //     catch (err) {
  //       throw (err)
  //     }
  //   }

  async getAllOrdersDetails(): Promise<CommonResponseModel> {
    try {
      let query = `
      SELECT 
        spo.buyer_style AS buyerStyle,
        spo.buyer_code AS OrdersbuyerCode,
        spo.buyer_address AS buyerAddress,
        spo.earliest_ex_fty AS earliestExFty,
        spo.delivery_date AS deliveryDate,
        spo.delivery_address AS deliveryAddress,
        spo.item_description AS itemDescription,
        spo.order_qty AS orderQty,
        spo.sales_price AS salesPrice,
        spo.discount_item,
        spo.currency,
        spo.status,
        spo.buyer_po AS buyerPo,
        spo.sample_item_no,
        bm.buyer_name AS buyerName,
        bm.sales_person AS salesPerson,
        bm.discount_one AS discountOne,
        bm.item_responsible AS itemResponsible,
        bm.delivery_terms AS deliveryTerms,
        bm.packaging_trims AS packagingTrims,
        bm.delivery_method AS deliveryMethod,
        bm.payment_method AS paymentMethod,
        bm.payment_terms AS paymentTerms,
        bm.facility,
        bm.ware_house AS wareHouse,
        bm.pch,
        bm.buyer_po_date AS buyerPoDate,
        bm.shipment_type AS shipmentType,
        bm.agent,
        bm.sp_qty AS spQty
      FROM sample_po_order spo
      LEFT JOIN buyer_master bm ON bm.buyer_code = spo.buyer_code
  ORDER BY spo.status = 'OPEN' OR spo.status='INPROGRESS' OR spo.status = 'FAILED', spo.created_at DESC`;

      const result = await this.buyerRepo.query(query);

      if (result.length > 0) {
        return new CommonResponseModel(true, 123, "Data Retrieved Successfully", result);
      } else {
        return new CommonResponseModel(false, 0, "No Data Found", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async createCoLineData(req?: SamplecoLineDto): Promise<any> {
    try {
      const entity = new SamplecoLineEntity();
      entity.agent = req.agent
      entity.buyerAddress = req.buyerAddress
      entity.buyerCode = req.buyerCode
      entity.itemNo = req.itemNo
      entity.itemResponsible = req.itemResponsible
      entity.salesPerson = req.salesPerson
      entity.orderQty = req.orderQty
      entity.deliveryDate = req.deliveryDate
      entity.buyerPo = req.buyerPo
      entity.shipmentType = req.shipmentType
      entity.status = req.status
      entity.coNumber = req.coNumber
      entity.coDate = req.coDate
      entity.errorMsg = req.errorMsg
      entity.buyerStyle = req.buyerStyle
      entity.itemDescription = req.itemDescription
      entity.salesPrice = req.salesPrice
      const save = await this.colineRepo.save(entity);
      if (save) {
        return new CommonResponseModel(true, 1, 'Created Sucessfully')
      } else {
        return new CommonResponseModel(false, 0, 'something went Wrong')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Error', err);
    }
  }

  async getColineData(req?: any): Promise<any> {
    try {
      const data = await this.colineRepo.getAllcolineData(req)
      if (data.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Sucessfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Error', err);
    }
  }

  async getDistinctPoNumber(): Promise<any> {
    try {
      const data = await this.buyerRepo.getDistinctPoNumber()

      if (data.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Sucessfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'something went Wrong')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Error', err);
    }
  }

  async getDistinctBuyerCode(): Promise<any> {
    try {
      const data = await this.repo.getDistinctBuyerCode()
      if (data.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Sucessfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No data Found', [])
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Error', err);
    }
  }

  async getDistinctBuyerStyle(req: any): Promise<any> {
    try {
      const data = await this.repo.getDistinctBuyerStyle(req)
      if (data.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Sucessfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No data Found', [])
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Error', err);
    }
  }

  async getOrderdataForCOline(req: any): Promise<CommonResponseModel> {
    try {
      const ordersData = await this.buyerRepo.find({ where: { buyerPo: req.buyerPo } });
      return new CommonResponseModel(true, 1, 'Data Retrieved Successfully');
    } catch (err) {
      console.log(err)
    }
  }

  async isAlertPresent(driver) {
    try {
      await driver.switchTo().alert();
      return true;
    } catch (e) {
      return false;
    }
  }

  @Cron('*/8 * * * *')
  async createCOline(req?: any): Promise<any> {

    interface OrderItem {
      buyerStyle: string;
      OrdersbuyerCode: string;
      buyerAddress: string;
      earliestExFty: string;
      deliveryAddress: string;
      discount_item: string;
      currency: string;
      status: string;
      buyerName: string;
      salesPerson: string;
      itemResponsible: string;
      deliveryTerms: string;
      packagingTrims: string;
      deliveryMethod: string;
      paymentMethod: string;
      paymentTerms: string;
      facility: string;
      wareHouse: string;
      pch: string;
      buyerPoDate: string | null;
      buyerPo: string;
      shipmentType: string;
      agent: string;
      sample_item_no: string;
      itemDescription: string;
      orderQty: string;
      salesPrice: string;
      spQty: string;
      discountOne: string;
      deliveryDate: string;
    }
    interface CommonResponseModel {
      data: OrderItem[];
    }
    const po = await this.repo.getSampleOrderDataForCoLine();
    if (!po) {
      return new CommonResponseModel(false, 0, 'No CO-Line creation records');
    }
    const response: any = await this.getAllOrdersDetails();
    const buyerDetails = response.data;

    const groupedData = buyerDetails.reduce((acc: any, item) => {
      const { OrdersbuyerCode, buyerStyle, buyerPo, sample_item_no, deliveryAddress, status, ...rest } = item;

      // Construct a unique key for grouping
      const key =
        OrdersbuyerCode === 'GAN00002' || OrdersbuyerCode === 'SKE00005'
          ? `${OrdersbuyerCode}_${buyerStyle}_${sample_item_no}_${deliveryAddress}_${status}`
          : `${OrdersbuyerCode}_${buyerStyle}_${buyerPo}_${sample_item_no}_${status}`;

      if (!acc[key]) {
        acc[key] = {
          buyerStyle,
          OrdersbuyerCode,
          buyerAddress: rest.buyerAddress,
          earliestExFty: rest.earliestExFty,
          deliveryAddress,
          discountItem: rest.discount_item,
          currency: rest.currency,
          buyerName: rest.buyerName,
          salesPerson: rest.salesPerson,
          itemResponsible: rest.itemResponsible,
          deliveryTerms: rest.deliveryTerms,
          packagingTrims: rest.packagingTrims,
          deliveryMethod: rest.deliveryMethod,
          paymentMethod: rest.paymentMethod,
          paymentTerms: rest.paymentTerms,
          facility: rest.facility,
          wareHouse: rest.wareHouse,
          pch: rest.pch,
          buyerPoDate: rest.buyerPoDate,
          buyerPo,
          shipmentType: rest.shipmentType,
          agent: rest.agent,
          delDate: rest.deliveryDate,
          status,
          items: [],
        };
      }

      // **Prevent duplicate items from being added**
      const isDuplicate = acc[key].items.some(
        (existingItem) =>
          existingItem.sample_item_no === sample_item_no &&
          existingItem.itemDescription === item.itemDescription &&
          existingItem.orderQty === item.orderQty &&
          existingItem.salesPrice === item.salesPrice &&
          existingItem.spQty === item.spQty &&
          existingItem.discountOne === item.discountOne &&
          existingItem.deliveryDate === item.deliveryDate
      );

      if (!isDuplicate) {
        acc[key].items.push({
          sample_item_no,
          itemDescription: item.itemDescription,
          orderQty: item.orderQty,
          salesPrice: item.salesPrice,
          spQty: item.spQty,
          discountOne: item.discountOne,
          deliveryDate: item.deliveryDate,
        });
      }

      return acc;
    }, {});

    const poData: any = Object.values(groupedData).filter((data: any) => data.status === "OPEN");

    const originalData = poData.length > 0 ? poData : []; // Ensure all "OPEN" records are included

    console.log(originalData, "Filtered PO Data");
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    let driverQuitFlag = false;
    const coData = poData.length > 0 ? poData[0] : [];
    console.log(coData, "coDatacoDatacoDatacoData")

    try {
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447#');
      await driver.findElement(By.id('username')).sendKeys('908244');
      await driver.findElement(By.id('password')).sendKeys('321@santhu');
      await driver.findElement(By.css('button.btn-primary')).click();
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447')
      // await driver.manage().deleteAllCookies();
      // console.log("Cookies cleared before login!");
      // await driver.executeScript(
      //   `javascript: openAccessPage('http://intranet.shahi.co.in:8080/IntraNet/CRMPRDNEW.jsp', 'CRM', '2448', 'R', '99901347', 'N', '20634576', 'null');`
      // );
      await driver.executeScript(
        `javascript:openAccessPage('http://crmm4.shahi.co.in:8080/CRMPRDN/CRMPRDNEW.jsp' , 'CRM' , '2448' , 'R' , '908244' , 'N', '50002840', 'N');`
      );
      await driver.sleep(2000)
      const jjFFF = await driver.getAllWindowHandles()
      await driver.switchTo().window(jjFFF[1]);
      await driver.wait(until.elementLocated(By.xpath("//div[contains(text(), 'Shahi GMT Warehouse-370')]")), 3000)
        .then(element => driver.wait(until.elementIsVisible(element), 2000))
        .then(element => driver.wait(until.elementIsEnabled(element), 1000))
        .then(element => element.click());

      if (coData) {
        for (const item of coData.items) {
          if (coData.OrdersbuyerCode === "GAN00002" || coData.OrdersbuyerCode === "SKE00005") {
            const update = await this.repo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, sampleItemNo: item.sample_item_no, deliveryAddress: coData.deliveryAddress }, { status: StatusEnum.INPROGRESS })
            console.log("GANT and SKECHERS Updated To INPROGRESS")
          } else {
            const update = await this.repo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, buyerPo: coData.buyerPo, sampleItemNo: item.sample_item_no }, { status: StatusEnum.INPROGRESS })
            console.log("ALL Updated To INPROGRESS")
          }
        }
      }
      await driver.sleep(6000)
      const windowHandles = await driver.getAllWindowHandles()
      await driver.switchTo().window(windowHandles[1]);
      const frame = await driver.findElement(By.id('mainFrame'));
      await driver.switchTo().frame(frame)

      const apps = await driver.wait(until.elementLocated(By.xpath('//*[@id="mainContainer"]/div[1]/div[2]')));
      const allApps = await apps.findElements(By.tagName('span'));
      for (const app of allApps) {
        if ((await app.getAttribute('innerText')).includes('Sampling Orders')) {
          await driver.executeScript('arguments[0].click();', app);
          break;
        }
      }
      await driver.sleep(9000)
      await driver.switchTo().frame(1)
      console.log("switched frame")
      await driver.sleep(1000)

      await driver.wait(until.elementLocated(By.id('addorderbtn')))
      await driver.findElement(By.id('addorderbtn')).click();
      console.log("Create Clicked")
      await driver.sleep(1000)

      try {
        await driver.wait(until.elementLocated(By.xpath("//*[contains(text(), 'Session Not Valid!!!')]")), 5000);
        console.log('Session Not Valid found');
        await driver.actions().keyDown(Key.CONTROL).sendKeys('r').keyUp(Key.CONTROL).perform();
        console.log("refresh clicked");
        await driver.manage().deleteAllCookies();
        console.log("Session Cookies 123");
        await driver.sleep(2000)
        if (coData) {
          for (const item of coData.items) {
            if (coData.OrdersbuyerCode === "GAN00002" || coData.OrdersbuyerCode === "SKE00005") {
              const update = await this.repo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, sampleItemNo: item.sample_item_no, deliveryAddress: coData.deliveryAddress }, { status: StatusEnum.OPEN })
              console.log("GANT and SKECHERS Updated To OPEN")
            } else {
              const update = await this.repo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, buyerPo: coData.buyerPo, sampleItemNo: item.sample_item_no }, { status: StatusEnum.OPEN })
              console.log("ALL Buyers Updated To OPEN")
            }
          }
        }
        await driver.manage().deleteAllCookies();
        console.log("Session Cookies 456");
        await driver.sleep(2000)
        await driver.quit();
        driverQuitFlag = true;
        await this.createCOline();
        return;
      }
      catch (error) {
        console.log("Session Not Valid not found... Proceed Next Steps...");
        await driver.wait(until.elementLocated(By.id('ctp')));
        const dropDonwElement1 = await driver.findElement(By.id('ctp'));
        const dropDown1 = await driver.wait(until.elementIsVisible(dropDonwElement1)).then(element => new Select(element));
        await dropDown1.selectByValue("KNT");
        console.log("KNT Selected");
        await driver.sleep(1000);

        await driver.wait(until.elementLocated(By.id('sap')));
        const dropdownElement2 = await driver.findElement(By.id('sap'));
        await driver.wait(until.elementIsVisible(dropdownElement2));
        const dropdown2 = new Select(dropdownElement2);
        await driver.wait(until.elementLocated(By.xpath(`//option[normalize-space(text()) = "${coData.salesPerson}"]`)));
        await dropdown2.selectByVisibleText(coData.salesPerson);
        console.log("SP")
        await driver.sleep(2000)

        // await driver.wait(until.elementLocated(By.id('ITEM_RESP')));
        // const itemDropDown = await driver.findElement(By.id('ITEM_RESP'));
        // const itemDropDownData = await driver.wait(until.elementIsVisible(itemDropDown)).then(element => new Select(element))
        // await itemDropDownData.selectByVisibleText(coData.itemResponsible)
        // console.log("ITR")

        const dropDonwElement78 = await driver.findElement(By.id('ITEM_RESP'));
        const dropDown63 = await driver.wait(until.elementIsVisible(dropDonwElement78)).then(element => new Select(element));
        try {
          await dropDown63.selectByVisibleText(coData.itemResponsible);
          console.log("Item Res selected by visible text");
        } catch (error) {
          console.log("Visible text not found, trying selectByValue");
          try {
            await dropDown63.selectByValue(coData.itemResponsible);
            console.log("Item Res selected by value");
          } catch (error) {
            console.log("Failed to select Item Res by both visible text and value");
          }
        }
        console.log("ITR")
        await driver.sleep(2000);

        await driver.wait(until.elementLocated(By.id('BUYER_PO')))
        await driver.findElement(By.id('BUYER_PO')).sendKeys(coData.buyerPo);
        console.log("Buyer PO Entered")
        await driver.sleep(1000)

        await driver.wait(until.elementLocated(By.id('SHIP_TYPEAUTO')))
        await driver.findElement(By.id('SHIP_TYPEAUTO')).clear();
        await driver.findElement(By.id('SHIP_TYPEAUTO')).sendKeys(coData.shipmentType);
        console.log("Shipment Type Entered")
        await driver.sleep(1000)

        await driver.wait(until.elementLocated(By.id('BUYER_STYLE')))
        await driver.findElement(By.id('BUYER_STYLE')).clear();
        await driver.findElement(By.id('BUYER_STYLE')).sendKeys(coData.buyerStyle);
        console.log("Buyer Style Entered")
        await driver.sleep(1000)

        await driver.wait(until.elementLocated(By.id('AGENTAUTO')))
        await driver.findElement(By.id('AGENTAUTO')).clear();
        await driver.findElement(By.id('AGENTAUTO')).sendKeys(coData.agent);
        console.log("Agent Entered")
        await driver.sleep(1000)

        console.log(coData.earliestExFty, "coData.earliestExFty")
        // console.log(dayjs(coData.earliestExFty).format("DD/MM/YYYY"),"dayjs ex")
        await driver.wait(until.elementLocated(By.name('dojo.EX_FACTORY')));
        await driver.findElement(By.name('dojo.EX_FACTORY')).clear();
        await driver.findElement(By.name('dojo.EX_FACTORY')).sendKeys(coData.earliestExFty);
        console.log("Ex fty Entered")
        await driver.sleep(1000)
        console.log(coData.delDate, "coData.delDate")
        // console.log(dayjs(coData.delDate).format("DD/MM/YYYY"),"dayjs del")ss
        await driver.wait(until.elementLocated(By.name('dojo.DEL_DATE')));
        await driver.findElement(By.name('dojo.DEL_DATE')).clear();
        await driver.findElement(By.name('dojo.DEL_DATE')).sendKeys(coData.delDate);
        console.log("Del Date Entered")
        await driver.sleep(1000)

        await driver.wait(until.elementLocated(By.id('PACK_TERMAUTO')));
        await driver.findElement(By.id('PACK_TERMAUTO')).clear();
        await driver.findElement(By.id('PACK_TERMAUTO')).sendKeys(coData.packagingTrims);
        console.log("Packaging Terms Entered")
        await driver.sleep(1000)

        await driver.wait(until.elementLocated(By.id('DEL_METHOD')));
        const deliveryMethodDatata = await driver.findElement(By.id('DEL_METHOD'));
        await driver.wait(until.elementIsVisible(deliveryMethodDatata));
        const delMethodDatata = new Select(deliveryMethodDatata);
        await driver.wait(until.elementLocated(By.xpath(`//option[normalize-space(text()) = "${coData.deliveryMethod}"]`)));
        await delMethodDatata.selectByVisibleText(coData.deliveryMethod);
        await driver.sleep(1000)
        console.log("DELIVERY METHOD")

        const dropDonwElement5 = await driver.findElement(By.id('DEL_TERMS'));
        const dropDown5 = await driver.wait(until.elementIsVisible(dropDonwElement5)).then(element => new Select(element));
        try {
          await dropDown5.selectByVisibleText(coData.deliveryTerms);
          console.log("Delivery Terms selected by visible text");
        } catch (error) {
          console.warn("Visible text not found, trying selectByValue");

          try {
            await dropDown5.selectByValue(coData.deliveryTerms);
            console.log("Delivery Terms selected by value");
          } catch (error) {
            console.error("Failed to select Delivery Terms by both visible text and value");
          }
        }
        console.log("DELIVERY TERMS")
        await driver.sleep(1000)
        // console.log(coData.deliveryTerms,"coData.deliveryTerms")
        // await driver.wait(until.elementLocated(By.id('DEL_TERMS')));
        // const deliveryTermData = await driver.findElement(By.id('DEL_TERMS'));
        // await driver.wait(until.elementIsVisible(deliveryTermData));
        // const ddTermsDd = new Select(deliveryTermData);
        // await driver.wait(until.elementLocated(By.xpath(`//option[normalize-space(text()) = "${coData.deliveryTerms}"]`)));
        // await ddTermsDd.selectByVisibleText(coData.deliveryTerms);
        // await driver.sleep(3000)

        console.log(coData.currency, "coData.currency")
        await driver.wait(until.elementLocated(By.id('CurrencyAUTO')));
        await driver.findElement(By.id('CurrencyAUTO')).clear();
        await driver.findElement(By.id('CurrencyAUTO')).sendKeys(coData.currency);
        console.log("Currency Entered")
        await driver.sleep(1000)


        await driver.wait(until.elementLocated(By.id('DISCOUNT')));
        await driver.findElement(By.id('DISCOUNT')).clear();
        await driver.findElement(By.id('DISCOUNT')).sendKeys(coData.discountItem);
        console.log("Discount 1 Entered")
        await driver.sleep(1000)

        await driver.wait(until.elementLocated(By.id('PAY_METHODAUTO')));
        await driver.findElement(By.id('PAY_METHODAUTO')).clear();
        await driver.findElement(By.id('PAY_METHODAUTO')).sendKeys(coData.paymentMethod);
        console.log("Payment Method Entered")
        await driver.sleep(1000)

        await driver.wait(until.elementLocated(By.id('PAY_TERMSAUTO')));
        await driver.findElement(By.id('PAY_TERMSAUTO')).clear();
        await driver.findElement(By.id('PAY_TERMSAUTO')).sendKeys(coData.paymentTerms);
        console.log("Payment Terms Entered")
        await driver.sleep(1000)

        await driver.executeScript('window.scrollTo(0, document.body.scrollHeight);');
        console.log("clicking item No")

        for (let jj = 0; jj < coData.items.length; jj++) {
          const item = coData.items[jj];

          if (jj === 0) {
            await driver.findElement(By.xpath('//*[@id="formId"]/table/tbody/tr[5]/td/table/tbody/tr[2]/td[1]/a/img')).click();
            console.log("Item No");
            await driver.sleep(2000);

            await driver.wait(until.elementLocated(By.name('handlenew')), 5000);
            await driver.switchTo().frame('handlenew');
            console.log("Switched to frame 'handlenew'");
            await driver.sleep(2000);

            await driver.wait(until.elementLocated(By.id('SEARCH_ITEM')));
            await driver.findElement(By.id('SEARCH_ITEM')).sendKeys(item.sample_item_no);
            console.log("ItemNo");
            await driver.sleep(2000);

            await driver.wait(until.elementLocated(By.id('listorderbtn')));
            await driver.findElement(By.id('listorderbtn')).click();
            console.log("Search Clicked");
            await driver.sleep(2000);

            await driver.executeScript(`
            document.body.style.width = '700px';
            document.body.style.height = '600px';
          `);
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('chk')));
            await driver.findElement(By.id('chk')).click();
            await driver.sleep(2000);

            await driver.findElement(By.xpath('/html/body/form/table/tbody/tr[1]/td/table/tbody/tr[2]/td[7]/a[3]/span/span/span')).click();
            await driver.sleep(1000);
            await driver.switchTo().defaultContent();
            await driver.sleep(2000);

            const Mainframe1 = await driver.findElement(By.id('mainFrame'));
            await driver.switchTo().frame(Mainframe1);
            await driver.sleep(2000);
            await driver.switchTo().frame(1);
            console.log("Switched frame again....");

            await driver.wait(until.elementLocated(By.id('ITEM_DESC_S')));
            await driver.findElement(By.id('ITEM_DESC_S')).clear();
            await driver.findElement(By.id('ITEM_DESC_S')).sendKeys(item.itemDescription);
            console.log("Item Description Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('ORDER_QTY_S')));
            await driver.findElement(By.id('ORDER_QTY_S')).clear();
            await driver.findElement(By.id('ORDER_QTY_S')).sendKeys(item.orderQty);
            console.log("Order Qty Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('SALES_PR_S')));
            await driver.findElement(By.id('SALES_PR_S')).clear();
            await driver.findElement(By.id('SALES_PR_S')).sendKeys(item.salesPrice);
            console.log("Sales Price Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('SP_QTY_S')));
            await driver.findElement(By.id('SP_QTY_S')).clear();
            await driver.findElement(By.id('SP_QTY_S')).sendKeys(item.spQty);
            console.log("SP Qty Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('DISC_S')));
            await driver.findElement(By.id('DISC_S')).clear();
            await driver.findElement(By.id('DISC_S')).sendKeys(item.discountOne);
            console.log("Discount 2 Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.name('dojo.date1')));
            await driver.findElement(By.name('dojo.date1')).clear();
            await driver.findElement(By.name('dojo.date1')).sendKeys(item.deliveryDate);
            console.log("Del Date 2 Entered");
            await driver.sleep(1000);

            await driver.executeScript('window.scrollTo(0, 0);');
            await driver.sleep(2000);

            await driver.wait(until.elementLocated(By.id('imgabc')));
            const element = await driver.findElement(By.id('imgabc'));
            await driver.executeScript("arguments[0].click();", element);

            await driver.switchTo().frame(0);
            console.log("Switched frame");
            await driver.sleep(2000);

            await driver.wait(until.elementLocated(By.id('buyer_code')));
            const buyerCodeInput = await driver.findElement(By.id('buyer_code'));
            await buyerCodeInput.sendKeys(coData.OrdersbuyerCode, Key.RETURN);

            await driver.wait(until.elementLocated(By.id('buyertemp')));
            const dropdownElement = await driver.findElement(By.id('buyertemp'));
            const dropdown = new Select(dropdownElement);
            await driver.wait(until.elementIsVisible(dropdownElement));
            await dropdown.selectByValue(coData.OrdersbuyerCode);
            await dropdownElement.sendKeys(Key.RETURN);
            console.log("Buyer Code Entered ");

            await driver.switchTo().defaultContent();
            await driver.sleep(2000)
            const frame1 = await driver.findElement(By.id('mainFrame'));
            await driver.switchTo().frame(frame1)
            await driver.sleep(2000)
            await driver.switchTo().frame(1);
            console.log("Switched frame again....");

            await driver.sleep(2000);
            await driver.wait(until.elementLocated(By.id('BUY_ADDRESS')));
            const buyerAddressData = await driver.findElement(By.id('BUY_ADDRESS'));
            const buyerAddressD = await driver.wait(until.elementIsVisible(buyerAddressData)).then(element => new Select(element));
            await buyerAddressD.selectByValue(coData.buyerAddress);
            console.log("BUYER ADDRESS")
            console.log(coData.buyerAddress, "coData.buyerAddress")

            await driver.sleep(2000);
            await driver.executeScript('window.scrollTo(0, document.body.scrollHeight);');
            await driver.sleep(2000);

            console.log(coData.deliveryAddress, "coData.deliveryAddress")
            await driver.wait(until.elementLocated(By.id('DEL_ADD_S')));
            const deliveryAddressData = await driver.findElement(By.id('DEL_ADD_S'));
            const deliveryAddressD = await driver.wait(until.elementIsVisible(deliveryAddressData)).then(element => new Select(element));
            await deliveryAddressD.selectByValue(coData.deliveryAddress);
            console.log("Delivery Address Selected");
            await driver.sleep(2000);

            await driver.executeScript('window.scrollTo(0, 0);');
            await driver.sleep(3000);
            console.log("Scrolled");
            await driver.findElement(By.id('savebtn')).click();
            console.log("Save button clicked");
            await driver.sleep(8000)
          }
          else {
            await driver.findElement(By.xpath('//*[@id="formId"]/table/tbody/tr[5]/td/table/tbody/tr[2]/td[1]/a/img')).click();
            console.log("Item No");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.name('handlenew')), 5000);
            await driver.switchTo().frame('handlenew');
            console.log("Switched to frame 'handlenew'");
            await driver.sleep(2000);

            await driver.wait(until.elementLocated(By.id('SEARCH_ITEM')));
            await driver.findElement(By.id('SEARCH_ITEM')).sendKeys(item.sample_item_no);
            console.log(item.sample_item_no, "ItemNo");
            await driver.sleep(2000);

            await driver.wait(until.elementLocated(By.id('listorderbtn')));
            await driver.findElement(By.id('listorderbtn')).click();
            console.log("Search Clicked");
            await driver.sleep(2000);

            await driver.executeScript(`
            document.body.style.width = '700px';
            document.body.style.height = '600px';
          `);
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('chk')));
            await driver.findElement(By.id('chk')).click();
            await driver.sleep(2000);

            await driver.findElement(By.xpath('/html/body/form/table/tbody/tr[1]/td/table/tbody/tr[2]/td[7]/a[3]/span/span/span')).click();
            await driver.sleep(1000);
            await driver.switchTo().defaultContent();
            await driver.sleep(2000);

            const Mainframe1 = await driver.findElement(By.id('mainFrame'));
            await driver.switchTo().frame(Mainframe1);
            await driver.sleep(2000);
            await driver.switchTo().frame(1);
            console.log("Switched frame again....");

            await driver.wait(until.elementLocated(By.id('ITEM_DESC_S')));
            await driver.findElement(By.id('ITEM_DESC_S')).clear();
            await driver.findElement(By.id('ITEM_DESC_S')).sendKeys(item.itemDescription);
            console.log("Item Description Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('ORDER_QTY_S')));
            await driver.findElement(By.id('ORDER_QTY_S')).clear();
            await driver.findElement(By.id('ORDER_QTY_S')).sendKeys(item.orderQty);
            console.log("Order Qty Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('SALES_PR_S')));
            await driver.findElement(By.id('SALES_PR_S')).clear();
            await driver.findElement(By.id('SALES_PR_S')).sendKeys(item.salesPrice);
            console.log("Sales Price Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('SP_QTY_S')));
            await driver.findElement(By.id('SP_QTY_S')).clear();
            await driver.findElement(By.id('SP_QTY_S')).sendKeys(item.spQty);
            console.log("SP Qty Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('DISC_S')));
            await driver.findElement(By.id('DISC_S')).clear();
            await driver.findElement(By.id('DISC_S')).sendKeys(item.discountOne);
            console.log("Discount 2 Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.name('dojo.date1')));
            await driver.findElement(By.name('dojo.date1')).clear();
            await driver.findElement(By.name('dojo.date1')).sendKeys(item.deliveryDate);
            console.log("Del Date 2 Entered");
            await driver.sleep(1000);

            await driver.wait(until.elementLocated(By.id('DEL_ADD_S')));
            const deliveryAddressData = await driver.findElement(By.id('DEL_ADD_S'));
            const deliveryAddressD = await driver.wait(until.elementIsVisible(deliveryAddressData)).then(element => new Select(element));
            await deliveryAddressD.selectByValue(coData.deliveryAddress);
            console.log("Delivery Address Selected");
            await driver.sleep(1000);

            await driver.findElement(By.xpath('//*[@id="addlinebtn"]')).click();
            console.log("Add Line button clicked");
            await driver.sleep(3000);
          }
        }
        await driver.sleep(3000)
        await driver.findElement(By.id('savebtn')).click();
        console.log("Save button clicked");
        await driver.sleep(2000)
        const coNoElement = await driver.wait(
          until.elementLocated(By.name('CO_NO')),
          11000
        );

        const coNo = await coNoElement.getAttribute('value');
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(currentDate);
        const year = currentDate.getFullYear().toString().slice(-2);
        const currentDateFormatted = `${day}-${month}-${year}`;
        console.log(coNo, "Conumber")
        try {
          if (coNo) {
            for (const item of coData.items) {
              const update = await this.createCoLineData({
                buyerPo: coData.buyerPo,
                buyerCode: coData.OrdersbuyerCode,
                buyerAddress: coData.buyerAddress,
                deliveryDate: coData.delDate,
                itemNo: item.sample_item_no,
                salesPerson: coData.salesPerson,
                // itemResponsible: coData?.itemResponsible,
                // itemResponsible:null,
                shipmentType: coData.shipmentType,
                agent: coData.agent,
                orderQty: item.orderQty,
                status: StatusEnum.SUCCESS,
                errorMsg: "-",
                coNumber: coNo,
                coDate: currentDateFormatted,
                buyerStyle: coData.buyerStyle,
                itemDescription: item.itemDescription,
                salesPrice: item.salesPrice,
                deliveryAddress: coData.deliveryAddress,
              });
            }
            await driver.sleep(7000)
            if (coData) {
              for (const item of coData.items) {
                if (coData.OrdersbuyerCode === "GAN00002" || coData.OrdersbuyerCode === "SKE00005") {
                  const updateOrders = await this.repo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, sampleItemNo: item.sample_item_no, deliveryAddress: coData.deliveryAddress }, { status: StatusEnum.SUCCESS })

                  const updateCoLine = await this.colineRepo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, itemNo: item.sample_item_no, deliveryAddress: coData.deliveryAddress }, { status: StatusEnum.SUCCESS, errorMsg: "-" })
                } else {
                  const update = await this.repo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, buyerPo: coData.buyerPo, sampleItemNo: item.sample_item_no }, { status: StatusEnum.SUCCESS })

                  const updateCoLine = await this.colineRepo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, buyerPo: coData.buyerPo, itemNo: item.sample_item_no }, { status: StatusEnum.SUCCESS, errorMsg: "-" })
                }
              }
            }

            await driver.sleep(2000)
            await driver.switchTo().defaultContent();
            await driver.sleep(2000)
            console.log("Went To Default Frame")

            await driver.switchTo().frame(0)
            console.log("Switched To Logout Frame")
            await driver.sleep(2000)

            let logoutButton = await driver.findElement(By.xpath('/html/body/div/form/table/tbody/tr/td[5]/div/a'));
            await logoutButton.click();
            await driver.sleep(2000)
            console.log("Now Clicked Logout Button")
            await driver.sleep(2000)

          }
        } catch (err) {
          await driver.wait(until.alertIsPresent(), 10000);
          const alert = await driver.switchTo().alert();
          await alert.accept();

          if (await this.isAlertPresent(driver)) {
            const alert = await driver.switchTo().alert();
            const alertText = await alert.getText();
            for (const item of coData.items) {
              const update = await this.createCoLineData({
                buyerPo: coData.buyerPo,
                buyerCode: coData.OrdersbuyerCode,
                buyerAddress: coData.buyerAddress,
                deliveryDate: coData.delDate,
                itemNo: item.sample_item_no,
                salesPerson: coData.salesPerson,
                // itemResponsible: null,
                shipmentType: coData.shipmentType,
                agent: coData.agent,
                orderQty: item.orderQty,
                status: StatusEnum.FAILED,
                errorMsg: err.name,
                coNumber: coNo,
                coDate: currentDateFormatted,
                buyerStyle: coData.buyerStyle,
                itemDescription: item.itemDescription,
                salesPrice: item.salesPrice,
                deliveryAddress: coData.deliveryAddress,
              });
            }
            for (const item of coData.items) {
              if (coData.OrdersbuyerCode === "GAN00002" || coData.OrdersbuyerCode === "SKE00005") {
                const updateOrders = await this.repo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, sampleItemNo: item.sample_item_no, deliveryAddress: coData.deliveryAddress }, { status: StatusEnum.FAILED })

                const updateCoLine = await this.colineRepo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, itemNo: item.sample_item_no, deliveryAddress: coData.deliveryAddress }, { status: StatusEnum.FAILED, errorMsg: err.name })
              }
              else {
                const updateOrders = await this.repo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, buyerPo: coData.buyerPo, sampleItemNo: item.sample_item_no }, { status: StatusEnum.FAILED })

                const updateCoLine = await this.colineRepo.update({ buyerCode: coData.OrdersbuyerCode, buyerStyle: coData.buyerStyle, buyerPo: coData.buyerPo, itemNo: item.sample_item_no }, { status: StatusEnum.FAILED, errorMsg: err.name })
              }
            }
            await driver.sleep(2000)
            await driver.switchTo().defaultContent();
            await driver.sleep(2000)
            console.log("Went To Default Frame")

            await driver.switchTo().frame(0)
            console.log("Switched To Logout Frame")
            await driver.sleep(2000)

            let logoutButton = await driver.findElement(By.xpath('/html/body/div/form/table/tbody/tr/td[5]/div/a'));
            await logoutButton.click();
            await driver.sleep(2000)
            console.log("Now Clicked Logout Button")
            await driver.sleep(5000)

            await alert.accept();
            await driver.sleep(4000)
            await driver.navigate().refresh();
            await driver.quit();

          }
        }
        return new CommonResponseModel(true, 1, `COline created successfully`)
      }
    }
    catch (err) {
      console.log(err.name, 'error.name')
      if (originalData) {
        for (const orginalItem of originalData.items) {
          console.log(orginalItem, "orginalItemorginalItemorginalItem")
          if (orginalItem.OrdersbuyerCode === "GAN00002" || orginalItem.OrdersbuyerCode === "SKE00005") {
            if (err.name.includes("no such element") || err.name.includes("no such element: Unable to locate element:") ||
              err.name.includes("no such window:") || err.name.includes("no such window: target window already closed from unknown error")) {
              const updateOrders = await this.repo.update({ buyerCode: originalData.OrdersbuyerCode, buyerStyle: originalData.buyerStyle, buyerPo: originalData.buyerPo, sampleItemNo: orginalItem.sample_item_no, deliveryAddress: orginalItem.deliveryAddress }, { status: StatusEnum.FAILED })
              const updateCoLine = await this.colineRepo.update({ buyerCode: originalData.OrdersbuyerCode, buyerStyle: originalData.buyerStyle, buyerPo: originalData.buyerPo, itemNo: orginalItem.sample_item_no, deliveryAddress: orginalItem.deliveryAddress }, { status: StatusEnum.FAILED, errorMsg: "CRM Error" })
            }
          } else {
            if (err.name.includes("no such element") || err.name.includes("no such element: Unable to locate element:") ||
              err.name.includes("no such window:") || err.name.includes("no such window: target window already closed from unknown error")) {
              const updateOrders = await this.repo.update({ buyerCode: originalData.OrdersbuyerCode, buyerStyle: originalData.buyerStyle, buyerPo: originalData.buyerPo, sampleItemNo: orginalItem.sample_item_no }, { status: StatusEnum.FAILED })
              const updateCoLine = await this.colineRepo.update({ buyerCode: originalData.OrdersbuyerCode, buyerStyle: originalData.buyerStyle, buyerPo: originalData.buyerPo, itemNo: orginalItem.sample_item_no }, { status: StatusEnum.FAILED, errorMsg: "CRM Error" })
            }
          }
        }
      }
      // const emailBot = await this.getCoLineDataAndSendEmail()
      // console.log(emailBot, "emailBot")
      return new CommonResponseModel(false, 0, err)
    }
    finally {
      if (!driverQuitFlag) {
        driver.quit()
      }
    }
  }

  //   async getSampleOrderDataForCoLine(req?: SamplecoLineFilterReq): Promise<CommonResponseModel> {
  //     console.log(req, "reqq22222222")
  //     try {
  //       const query = `SELECT 
  //   ex.buyer_style,
  //   ex.buyer_code,
  //   ex.buyer_address,
  //   ex.earliest_ex_fty,
  //   ex.delivery_date,
  //   ex.delivery_address,
  //   ex.item_description,
  //   ex.order_qty,
  //   ex.sales_price,
  //   ex.currency,
  //   ex.discount_item,
  //   ex.sample_item_no,
  //   spo.buyer_name,
  //   spo.sales_person,
  //   spo.discount_one,
  //   spo.item_responsible,
  //   spo.delivery_terms,
  //   spo.packaging_trims,
  //   spo.delivery_method,
  //   spo.payment_method,
  //   spo.payment_terms,
  //   spo.facility,
  //   spo.ware_house,
  //   spo.pch,
  //   spo.buyer_po_date,
  //   spo.buyer_po,
  //   spo.shipment_type,
  //   spo.agent,
  //   spo.sp_qty

  // FROM sample_po_orders spo
  // LEFT JOIN excel ex ON ex.buyer_code = spo.buyer_code

  // WHERE spo.buyer_po = '${req.buyerPo}' AND spo.buyer_code = '${req.buyerCode}'`
  //       const data = await this.dataSource.query(query)

  //       if (data.length > 0) {
  //         return new CommonResponseModel(true, 0, 'Data retrieved successfully', data)
  //       } else {
  //         return new CommonResponseModel(false, 1, 'No data found', [])
  //       }
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  async updateItemNo(req: coLineFilter): Promise<CommonResponseModel> {
    // console.log(req, "reqq");
    try {
      const update = await this.colineRepo.update(
        { id: Number(req.id), buyerCode: req.buyerCode },
        { itemNo: req.itemNo }
      );

      if (update.affected) {
        const update1 = await this.repo.update(
          { buyerCode: req.buyerCode }, { sampleItemNo: req.itemNo }
        );
        return new CommonResponseModel(true, 1, "Updated Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Something Went Wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while updating ItemNo", error);
    }
  }

  async deleteCoLine(req: coLineFilter): Promise<CommonResponseModel> {
    // console.log(req, "reqq");
    try {
      const deletedItem = await this.colineRepo.delete({ id: Number(req.id) });
      if (deletedItem && deletedItem.affected) {
        const updateData = await this.repo.update({ buyerPo: req.poNumber, buyerCode: req.buyerCode, buyerStyle: req.buyerStyle, sampleItemNo: req.itemNo }, { status: StatusEnum.OPEN, isActive: true })
        return new CommonResponseModel(true, 1, "Deleted Successfully");
      }
      return new CommonResponseModel(false, 0, "No records found to delete", []);
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
    }
  }

  async getCoLineDataAndSendEmail(req?: SamplecoLineFilterReq): Promise<CommonResponseModel> {
    const recipientEmail = 'saiprakash.katiki@gmail.com';
    const ccEmails = ['santhosh.palaksha@shahi.co.in', 'manu.gupta@shahi.co.in', 'pradeep@schemaxtech.com', 'sujatha@schemaxtech.com'];
    const response = await this.colineRepo.find({ where: { buyerCode: req?.buyerCode, status: req?.status } });
    // console.log(response, "Response");

    const failedPoNumbersData: string[] = [];
    response.forEach(po => {
      if (po.buyerCode && po.status === 'FAILED') {
        failedPoNumbersData.push(po.buyerCode);
      }
    });
    // console.log(failedPoNumbersData, "Failed");sf
    const coLineFailedData = response.filter(item => item.status === 'FAILED');
    // console.log(coLineFailedData, "cococcoooooooo")
    if (coLineFailedData.length > 0) {
      const errorMessage = coLineFailedData.map(item => `
          BUyer Code: ${item.buyerCode}
          Buyer Name: Sample PO
          Item No: ${item.itemNo}
          Sales Person: ${item.salesPerson}
          Item Responsible: ${item.itemResponsible}
          Status : ${item.status}
          CO Date: ${item.coDate}
          CO Number: ${item.coNumber}
          Message: ${item.errorMsg}
        `).join('\n\n');

      const transporter = nodemailer.createTransport({
        host: 'smtp.gmail.com',
        port: 587,
        secure: false,
        auth: {
          user: 'jaswanthpappala3@gmail.com',
          pass: 'ohgq yfmd mecb vrzw'
        }
      });

      const mailOptions = {
        from: 'jaswanthpappala3@gmail.com',
        to: recipientEmail,
        cc: ccEmails,
        subject: 'Sample PO CO Line Failed Status',
        text: `Dear User,\n\n Sample PO CO Line Data:\n\n${errorMessage}\n\nRegards,\nSample PO BOT`,
      };

      await transporter.sendMail(mailOptions);
      return new CommonResponseModel(true, 1, "Email Sent Successfully");
    } else {
      console.log("No Failed Records");
      return new CommonResponseModel(false, 0, "No Records with Failed status");
    }
  }
}

// async deleteCoLine(req: coLineFilter): Promise<CommonResponseModel> {
//   console.log(req, "reqq");
//   try {
//     const itemToDelete = await this.colineRepo.findOne({ where: { id: Number(req.id) } });

//     if (!itemToDelete) {
//       return new CommonResponseModel(false, 0, "Item No not found", []);
//     }

//     if (itemToDelete.status === StatusEnum.SUCCESS) {
//       itemToDelete.isActive = Boolean(0);
//       await this.colineRepo.save(itemToDelete);
//       const update1 = await this.repo.update(
//         { buyerPo:req.poNumber,buyerCode: req.buyerCode, buyerStyle: req.buyerStyle, }, { status: StatusEnum.OPEN, isActive: true }
//       );
//       return new CommonResponseModel(true, 1, "Deleted Successfully");
//     } else {
//       const deleteResult = await this.colineRepo.delete({ id: Number(req.id) });

//       if (deleteResult && deleteResult.affected) {
//         return new CommonResponseModel(true, 1, "Deleted Successfully");
//       } else {
//         return new CommonResponseModel(false, 0, "Something Went Wrong", []);
//       }
//     }
//   } catch (error) {
//     return new CommonResponseModel(false, 0, "Error occurred while deleting or updating ItemNo status", error);
//   }
// }